<script lang="ts">
	import '../app.css'
	import { onMount, type Component } from 'svelte'

	type Props = {
		children?: import('svelte').Snippet
	}

	const { children }: Props = $props()

	let DevTools = $state<Component | null>(null)

	onMount(async () => {
		// `import.meta.env.DEV` (not `dev` from $app/environment) so Vite substitutes
		// the literal `false` during transform, before Rollup builds the module graph:
		// the import() then never exists in production and no chunk is emitted for it.
		// `dev` folds too late — the orphan chunk still lands in build/.
		// Do NOT turn this into a static import.
		if (import.meta.env.DEV) {
			const devTools = await import('$lib/app/dev-tools')
			DevTools = devTools.DevToolsPanel
		}
	})
</script>

{@render children?.()}

{#if DevTools}
	<DevTools />
{/if}
